import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useEffect, useState } from 'react';
import LockIcon from '@mui/icons-material/Lock';
import BlockIcon from '@mui/icons-material/Block';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import Form from 'react-bootstrap/Form';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import Switch from '@mui/material/Switch';
import { switchProps } from '../../muiStyles/muiSwitch';
import { centerClient } from '../../../shared/clients';
import type { SetBannedModel, SetBlockedModel, SetBalanceModel, SetDealerCostModel, SetChargeModel, SetTestModeModel, CommandResult, Device } from '../../../shared/generated';
import context from '../context/shared';
import { buildDeviceId } from '../../../utils/deviceId';
import { Calculator, CalendarCheck } from 'react-bootstrap-icons';
import { Dropdown } from 'rsuite';
interface ISetDevicePropertyFormProps {
    propertyName: keyof(Device);
    title: string;
    label: string;
    devices: Device[];
    isMobile?: boolean;
}
function SetDevicePropertyForm(props: ISetDevicePropertyFormProps) {
    const { propertyName, title, label, devices, isMobile } = props;
    const labelProps = { inputProps: { 'aria-label': label } };
    const errorStr = "Необходимо заполнить поле ";
    const { refreshTree } = context;
    const types = {
        bool: "checkbox",
        input: "input",
        none: "none"
    }
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (!show)
            return;
        if (getType() !== 'checkbox')
            return;

        const blocked = devices.filter(val => val[propertyName] === true).length;
        const unBlocked = devices.filter(val => val[propertyName] === false).length;
        if (blocked === 0 && unBlocked > 0)
            setDeviceBoolProperty(false)
        else if (unBlocked === 0 && blocked > 0)
            setDeviceBoolProperty(true)
    }, [show])
    const [deviceBoolProperty, setDeviceBoolProperty] = useState(false);
    const getType = () => {
        switch (propertyName) {
            case 'Banned':
            case 'Blocked':
                return "checkbox";
            case 'Balance':
            case 'Cost':
            case 'Charge':
                return "input";
            case 'TestMode':
                return "none";
        }
    }
    const getBoolVariants = () => {
        switch (propertyName) {
            case 'Banned':
                return {
                    on: "Отключить",
                    off: "Включить"
                }
            case 'Blocked':
                return {
                    off: "Разблокировать",
                    on: "Заблокировать"
                }
            default:
                return {
                    off: "Откл.",
                    on: "Вкл."
                }
        }
    }
    const successSet = (res?: CommandResult) => {
        if (res?.Success) {
            handleClose();
            toast.success("Свойства контроллера/ов изменены!", { autoClose: 1500 });
            refreshTree();
            if (res.Description)
                toast.info(res.Description);
        }
        else {
            handleClose();
            refreshTree();
            toast.error(res?.Description);
        }
    }
    const errorSet = () => {
        handleClose();
        refreshTree();
    }
    const handleChangeProperty = (value) => {
        const deviceIds = getSelectedDeviceIds(devices);
        let promise: Promise<unknown> | null = null;
        switch (propertyName) {
            case 'Banned': {
                const model: SetBannedModel = { DeviceIds: deviceIds, Banned: value };
                promise = centerClient.setBanned(model);
                break;
            }
            case 'Blocked': {
                const model: SetBlockedModel = { DeviceIds: deviceIds, Blocked: value };
                promise = centerClient.setBlocked(model);
                break;
            }
            case 'Balance': {
                const model: SetBalanceModel = { DeviceIds: deviceIds, Balance: value };
                promise = centerClient.setBalance(model);
                break;
            }
            case 'Cost': {
                const model: SetDealerCostModel = { DeviceIds: deviceIds, Cost: value };
                promise = centerClient.setCost(model);
                break;
            }
            case 'Charge': {
                const model: SetChargeModel = { DeviceIds: deviceIds, Charge: value };
                promise = centerClient.setCharge(model);
                break;
            }
            case 'TestMode': {
                const model: SetTestModeModel = { DeviceIds: deviceIds };
                promise = centerClient.setTestMode(model);
                break;
            }
        }
        if (promise)
            promise
                .then((res) => successSet((res as any)?.data))
                .catch(() => errorSet());
    }
    const {
        register, handleSubmit,
        formState: { errors }
    } = useForm();
    const handleShow = () => {
        if (devices.length > 0)
            setShow(true);
        else
            toast.info("Необходимо выбрать хотя бы один контроллер");
    }
    const handleClose = () => {
        setShow(false);
    }
    const handleSetBoolProperty = () => {
        handleChangeProperty(deviceBoolProperty);
    }

    const getSelectedDeviceIds = (devices: Device[]) => {
        const serialNumbers: string[] = [];
        devices.map((row) => {
            const deviceToRemove = row;
            const deviceId = buildDeviceId(deviceToRemove.Model, deviceToRemove.Serial);
            serialNumbers.push(deviceId);
        })
        return serialNumbers;
    }
    const handleSetProperty = (data) => {
        handleChangeProperty(data[propertyName]);
    }
    const handleChangeBoolProperty = () => {
        setDeviceBoolProperty(prev =>
            !prev)
    }
    const getSvgForProperty = () => {
        switch (propertyName) {
            case 'Banned':
                return <BlockIcon style={getSvgStyle()} />
            case 'Blocked':
                return <LockIcon style={getSvgStyle()} />
            case 'Balance':
                return <CreditCardIcon style={getSvgStyle()} />
            case 'Cost':
                return <LocalAtmIcon style={getSvgStyle()} />
            case 'Charge':
                return <Calculator style={getSvgStyle()} />
            case 'TestMode':
                return <CalendarCheck style={getSvgStyle()} />
            default:
                return "";
        }
    }
    const getSvgStyle = () => {
        if (!isMobile)
            return { fill: "var(--text-dark)" };
        else
            return { marginRight: '.5rem', width: '1.25rem', height:'1.25rem' };
    }
    
    return (
        <>
            {
                isMobile ? 
                    <Dropdown.Item onClick={handleShow}>
                        {getSvgForProperty()}
                        {title}
                    </Dropdown.Item>
                    :
                    <Button title={title} variant="custom" onClick={handleShow} className="centerButton">{getSvgForProperty()}</Button>
            }
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            {
                                getType() == types.input ?
                                    <>
                                        <Form.Label>{label}</Form.Label>
                                        <Form.Control type="number"  {...register(propertyName, { required: true })} min={0} placeholder={label} />
                                        {errors[propertyName] && <p>{errorStr + label}.</p>}
                                    </>
                                    : getType() == types.bool ?
                                    <>
                                        {getBoolVariants().off}
                                        <Switch
                                            value={deviceBoolProperty}
                                            checked={deviceBoolProperty}
                                            {...labelProps}
                                            name={propertyName}
                                            onChange={handleChangeBoolProperty}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                            sx={switchProps}
                                        />
                                        {getBoolVariants().on}
                                        </> :
                                    <>Установить тестовый режим на 14 дней?</>
                            }
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>                    
                    {
                        getType() == types.input ?
                            <Button variant="custom" onClick={handleSubmit((data) => handleSetProperty(data))}>
                            Установить
                        </Button>
                        :
                        <Button variant="custom" onClick={handleSetBoolProperty}>
                           Установить
                        </Button>
                    }
                    <Button variant="custom" onClick={handleClose}>
                        Закрыть
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default SetDevicePropertyForm;